import React, { useState, useEffect } from 'react';
import { HashRouter as Router } from 'react-router-dom';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import DailyTracker from './components/DailyTracker';
import ProjectTracker from './components/ProjectTracker';
import Footer from './components/Footer';
import { motion, AnimatePresence } from 'framer-motion';
import './App.css';

function App() {
  const [currentView, setCurrentView] = useState('dashboard');

  useEffect(() => {
    // Set initial view based on URL hash
    const hash = window.location.hash.replace('#/', '') || 'dashboard';
    setCurrentView(hash);

    // Listen for hash changes
    const handleHashChange = () => {
      const newHash = window.location.hash.replace('#/', '') || 'dashboard';
      setCurrentView(newHash);
    };

    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  const handleViewChange = (view) => {
    setCurrentView(view);
    window.location.hash = `#/${view}`;
  };

  const renderCurrentView = () => {
    switch (currentView) {
      case 'daily':
        return <DailyTracker />;
      case 'project':
        return <ProjectTracker />;
      default:
        return <Dashboard setCurrentView={handleViewChange} />;
    }
  };

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
        <div className="container mx-auto px-4 py-6">
          <Header currentView={currentView} setCurrentView={handleViewChange} />
          
          <main className="mt-8">
            <AnimatePresence mode="wait">
              <motion.div
                key={currentView}
                initial={{ opacity: 0, x: 20 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: -20 }}
                transition={{ duration: 0.3 }}
              >
                {renderCurrentView()}
              </motion.div>
            </AnimatePresence>
          </main>

          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;